/* HE Aug 25 2026: product description accordion.
   Turns the house description sections (Description, Key Features,
   Size & Details, Includes, Fitment & Notes, Disclaimer, plus any
   other short bold-only heading) into a <details> accordion. The
   Description text stays open as plain paragraphs under a small
   "Description" eyebrow heading; every other section starts
   collapsed (Happy, Aug 26 2026). The HTML the page ships is unchanged, so
   search engines and screen readers get the same content whether
   or not this runs. Styling lives in he-custom.css (Fix 56) and,
   for the eyebrow, in snippets/product-description.liquid (Fix 61).

   HOW A HEADING IS RECOGNISED. Product descriptions were written
   over several years and several editors, so the markup varies:
     <p><strong>Key Features</strong></p>
     <p><strong style="...">Key Features</strong></p>
     <p data-start=".."><strong>Description<br></strong><br>Body text
     <h3>Key Features</h3>
   A block counts as a heading when it starts with a <strong> (or is
   an h2 to h4) whose own text is short (under 48 characters) and
   does not end in a period. If body text follows the heading inside
   the same block (the third form above), it is split out into its
   own paragraph so the heading can become the summary.
   Everything before the first heading, and the body of the first
   "Description" heading, stays open. A product with fewer than two
   headings is left untouched. */
(function () {
  'use strict';

  var KNOWN = /^(description|key features|size (&|and) details|includes|what'?s included|fitment( (&|and) notes)?|disclaimer|(quick )?install|care (note|tips)|notes|popular fitments.*|fading disclaimer.*)$/i;

  function textOf(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function isHeadingBlock(el) {
    if (!el || el.nodeType !== 1) return null;
    var tag = el.tagName;
    if (tag === 'H2' || tag === 'H3' || tag === 'H4') {
      var t = textOf(el);
      return t && t.length < 48 && !/[.:!?]$/.test(t) ? { text: t, strong: null } : null;
    }
    if (tag !== 'P' && tag !== 'DIV') return null;
    // A plain paragraph that IS one of the house headings (an editor
    // forgot the bold) still counts.
    if (!el.querySelector('strong, b') && KNOWN.test(textOf(el))) return { text: textOf(el), strong: null };
    // first meaningful child must be a <strong>/<b>
    var first = null;
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && !n.textContent.trim()) continue;
      first = n; break;
    }
    if (!first || first.nodeType !== 1) return null;
    if (first.tagName !== 'STRONG' && first.tagName !== 'B') return null;
    var ht = textOf(first);
    if (!ht || ht.length >= 48 || /[.:!?]$/.test(ht)) return null;
    // Bold-only paragraph, or bold heading followed by <br> and body text.
    var rest = textOf(el).slice(ht.length).trim();
    if (rest && !startsWithBreak(first)) return null;
    return { text: ht, strong: first, hasBody: !!rest };
  }

  // true when the node after the <strong> (or inside its tail) is a <br>
  function startsWithBreak(strong) {
    var inner = strong.lastChild;
    if (inner && inner.nodeType === 1 && inner.tagName === 'BR') return true;
    var n = strong.nextSibling;
    while (n && n.nodeType === 3 && !n.textContent.trim()) n = n.nextSibling;
    return !!(n && n.nodeType === 1 && n.tagName === 'BR');
  }

  // Split "<p><strong>Heading<br></strong><br>Body...</p>" into a heading
  // paragraph and a body paragraph, returning the heading element.
  function splitHeading(el, info) {
    var body = document.createElement('p');
    var sawContent = false;
    var n = info.strong.nextSibling, next;
    while (n) {
      next = n.nextSibling;
      if (!sawContent && ((n.nodeType === 1 && n.tagName === 'BR') || (n.nodeType === 3 && !n.textContent.trim()))) {
        el.removeChild(n);
      } else {
        sawContent = true;
        body.appendChild(n);
      }
      n = next;
    }
    // strip a trailing <br> inside the strong
    var last = info.strong.lastChild;
    if (last && last.nodeType === 1 && last.tagName === 'BR') info.strong.removeChild(last);
    if (body.childNodes.length) el.parentNode.insertBefore(body, el.nextSibling);
    return el;
  }

  function build(root) {
    if (!root || root.dataset.heAccordion) return;
    var blocks = Array.prototype.slice.call(root.childNodes);
    var sections = [];   // {heading, nodes:[]}
    var lead = [];       // nodes before the first heading
    var current = null;

    blocks.forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === 'HR') { node.parentNode.removeChild(node); return; }
      if (node.nodeType === 3 && !node.textContent.trim()) { node.parentNode.removeChild(node); return; }
      var info = isHeadingBlock(node);
      if (info) {
        if (info.hasBody) splitHeading(node, info);
        current = { heading: info.text, el: node, nodes: [] };
        sections.push(current);
        // pick up the body paragraph created by the split
        if (info.hasBody && node.nextSibling) { current.nodes.push(node.nextSibling); }
      } else if (current) {
        if (current.nodes.indexOf(node) === -1) current.nodes.push(node);
      } else {
        lead.push(node);
      }
    });

    if (sections.length < 2) return;
    root.dataset.heAccordion = 'on';

    var frag = document.createDocumentFragment();
    lead.forEach(function (n) { frag.appendChild(n); });

    sections.forEach(function (s, i) {
      var isDescription = i === 0 && /^description$/i.test(s.heading);
      if (isDescription) {
        // Keep the copy open, and keep the label. Without it the opening
        // paragraph reads as orphaned above a stack of labelled cards
        // (Happy, Aug 26 2026). It is rendered as a small eyebrow heading
        // rather than a summary so it stays visually distinct from the
        // sections that actually collapse. Styling is Fix 61.
        s.el.parentNode && s.el.parentNode.removeChild(s.el);
        var eyebrow = document.createElement('h2');
        eyebrow.className = 'he-pdp-eyebrow';
        eyebrow.textContent = s.heading;
        frag.appendChild(eyebrow);
        var intro = document.createElement('div');
        intro.className = 'he-pdp-intro';
        s.nodes.forEach(function (n) { intro.appendChild(n); });
        frag.appendChild(intro);
        return;
      }
      var d = document.createElement('details');
      d.className = 'he-pdp-acc';
      // Every section starts collapsed; only the Description copy above is open.
      var sum = document.createElement('summary');
      sum.innerHTML = '<span>' + escapeHtml(s.heading) + '</span>' +
        '<svg class="he-pdp-caret" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>';
      var body = document.createElement('div');
      body.className = 'he-pdp-body';
      s.nodes.forEach(function (n) { body.appendChild(n); });
      s.el.parentNode && s.el.parentNode.removeChild(s.el);
      d.appendChild(sum);
      d.appendChild(body);
      frag.appendChild(d);
    });

    root.innerHTML = '';
    root.appendChild(frag);
  }

  function escapeHtml(s) {
    return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function init() {
    var roots = document.querySelectorAll('[data-he-pdp-description]');
    if (!roots.length) roots = document.querySelectorAll('.product-single__description.rte, .product-block--description .rte');
    Array.prototype.forEach.call(roots, build);
  }

  if (typeof window !== 'undefined' && window.document) {
    // The script tag sits directly after the description markup, so the
    // description is already parsed when this runs: build it now to avoid
    // a flash of the unstyled list. Fall back to DOMContentLoaded if the
    // script is ever moved into the head.
    if (document.querySelector('[data-he-pdp-description]') || document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  }
  if (typeof module !== 'undefined') module.exports = { build: build };
})();
